import { render, staticRenderFns } from "./Heronew.vue?vue&type=template&id=ef0a3562&scoped=true"
import script from "./Heronew.vue?vue&type=script&lang=js"
export * from "./Heronew.vue?vue&type=script&lang=js"
import style0 from "./Heronew.vue?vue&type=style&index=0&id=ef0a3562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0a3562",
  null
  
)

export default component.exports